import React, { useState, useEffect } from 'react';
import styles from './templateStyle.module.css';
import { Text } from '../Text';
import { ReactComponent as PreviewHeader } from '../../assets/new_preview_header.svg';
import { ReactComponent as PreviewFooter } from '../../assets/new_preview_footer.svg';
const TemplatePreview = ({
  header = '',
  content = '',
  file = null,
  videoPreview = null,
  documentPreview = null,
  imagePreview = null,
  footer = '',
  buttons = [],
}) => {
  const [showAllButtons, setShowAllButtons] = useState(false);
  const [showPreviewOverlay, setShowPreviewOverlay] = useState(false);

  useEffect(() => {
    setShowAllButtons(false);
    setShowPreviewOverlay(false);
  }, [buttons]);

  const displayedButtons = showAllButtons
    ? buttons
    : buttons.length > 3
      ? [...buttons.slice(0, 2), { id: 'see-all', text: 'See all options', type: 'SEE_ALL' }]
      : buttons;

  return (
    <div className={` flex flex-column justify-content-end gap-2`}>
      {/* 🔼 Arrow Toggle Button */}
      {buttons.length > 3 && (
        <div className="flex justify-content-end p-2">
          <button
            onClick={() => setShowPreviewOverlay((prev) => !prev)}
            type="button"
            style={{
              background: 'none',
              border: '1px solid #708090 ',
              // fontSize: "1rem",
              cursor: 'pointer',
              padding: '8px',
            }}
          >
            <i
              className="pi pi-chevron-right"
              si
              style={{ color: '#708090', fontSize: '0.75rem' }}
            ></i>
          </button>
        </div>
      )}

      <div className={` flex flex-column ${styles['mobile-preview']}`}>
        <div className={`flex ${styles['logo-container']}`}>
          <PreviewHeader className="w-full h-full" />
        </div>
        <div className={`w-full flex-grow-1 ${styles['body-container']}`}>
          <div className={`mx-2 mt-2 p-2 ${styles['message-card']}`}>
            <div>
              {(imagePreview || videoPreview || documentPreview) && (
                <div className="img-preview">
                  {imagePreview != null && (
                    <img
                      src={imagePreview}
                      alt=""
                      style={{
                        objectFit: 'cover',
                        width: '100%',
                        maxHeight: '180px',
                      }}
                    />
                  )}
                  {videoPreview != null && (
                    <video
                      controls
                      src={videoPreview}
                      style={{
                        objectFit: 'cover',
                        width: '100%',
                        maxHeight: '180px',
                      }}
                    ></video>
                  )}
                  {documentPreview != null && (
                    <iframe
                      frameBorder={0}
                      src={documentPreview}
                      style={{
                        width: '100%',
                        overflow: 'hidden',
                        maxHeight: '180px',
                      }}
                    />
                  )}
                </div>
              )}
              {header && <Text type={'heading'}>{header}</Text>}
              {content && (
                <Text type="sub-heading" style={{ whiteSpace: 'pre-line' }}>
                  {content}
                </Text>
              )}
              {footer && (
                <Text type="sub-heading" color={'grey'} style={{ fontSize: '0.8rem' }}>
                  {footer}
                </Text>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-column gap-2 m-2">
            {displayedButtons.map((item, i) => {
              const isSeeAll = item?.type === 'SEE_ALL';
              return (
                <div
                  key={item?.id || i}
                  className="w-full p-2 flex-grow-1 flex justify-content-center align-items-center gap-2 cursor-pointer"
                  style={{ backgroundColor: '#f5f6f7', borderRadius: '10px' }}
                  onClick={() => {
                    if (isSeeAll) {
                      setShowAllButtons(true);
                    }
                  }}
                >
                  {item?.type === 'PHONE_NUMBER' && (
                    <i className={`pi pi-phone ${styles['preview-icons']}`} />
                  )}
                  {item?.type === 'URL' && (
                    <i className={`pi pi-external-link ${styles['preview-icons']}`} />
                  )}
                  <Text type={'sub-heading'} color={'#068FFF'}>
                    {item?.text}
                  </Text>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${styles['logo-container']}`}>
          <PreviewFooter width={'100%'} height={'100%'} />
        </div>

        {/* 🔲 Overlay Panel */}
        {showPreviewOverlay && (
          <div
            className="absolute top-0 left-0 w-full h-full z-50 border-1"
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              backdropFilter: 'blur(4px)',
            }}
          >
            <div
              className="absolute bottom-0 w-full bg-white p-4"
              style={{
                maxHeight: '60%',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                overflowY: 'auto',
              }}
            >
              {/* Close Button */}
              <div className="flex justify-content-end mb-2">
                <button
                  onClick={() => setShowPreviewOverlay(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                  }}
                >
                  <i className="pi pi-times" style={{ fontSize: '1rem', color: '#708090' }}></i>
                </button>
              </div>

              {/* All Buttons (Vertical List) */}
              <div className="flex flex-column gap-2">
                {buttons.map((item, i) => (
                  <div
                    key={item?.id || i}
                    className="w-full p-2 flex justify-content-center align-items-center gap-2 cursor-pointer"
                    style={{ backgroundColor: '#f5f6f7', borderRadius: '10px' }}
                  >
                    {item?.type === 'PHONE_NUMBER' && (
                      <i className={`pi pi-phone ${styles['preview-icons']}`} />
                    )}
                    {item?.type === 'URL' && (
                      <i className={`pi pi-external-link ${styles['preview-icons']}`} />
                    )}
                    <Text type={'sub-heading'} color={'#068FFF'}>
                      {item?.text}
                    </Text>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplatePreview;
